/** Guest-chat contract skip flag — persisted per token, like the language choice. */

export function contractSkipKey(token: string): string {
  return `meshcore-guest-contract-skip:${token}`;
}

export function readContractSkip(token: string): boolean {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(contractSkipKey(token)) === "1";
}

export function writeContractSkip(token: string): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(contractSkipKey(token), "1");
}
